import type {
    ActionResponse,
    ActionResponseWithMessage,
    ActionResponseWithNestedResponses,
    ActionResponseWithText,
    ExceptionActionResponse,
    ExtendedDocument,
    FinishedActionResponse,
    RichDocument
} from 'typings/portaro.be.types';
import type {ModalWindowResult, PayloadActionResponse} from 'typings/portaro.fe.types';
import {recordTypes} from '../../commons/constants/portaro.constants';
import type {IHttpResponse} from 'angular';

export function isExceptionActionResponse(object): object is ExceptionActionResponse {
    return !!(object && object.simpleName && object.finished !== undefined && object.responseType);
}

export function isActionResponseWithMessage(object): object is ActionResponseWithMessage {
    return !!(object && object.message && object.finished !== undefined && object.responseType);
}

export function isActionResponse(object): object is ActionResponse {
    return !!(object && object.finished !== undefined && object.responseType);
}

export function isIHttpResponse<T>(object): object is IHttpResponse<T> {
    return !!(object && object.data && object.status && object.headers && object.config && object.statusText !== undefined && object.xhrStatus);
}

export function isFinishedActionResponse(object): object is FinishedActionResponse {
    return !!(object && object.text && object.finished !== undefined && object.responseType);
}

export function isActionResponseWithText(object): object is ActionResponseWithText {
    return !!(object && object.text && object.finished !== undefined && object.responseType);
}

export function isActionResponseWithNestedResponses(object): object is ActionResponseWithNestedResponses {
    return !!(object && object.finishedResponses && object.finished !== undefined && object.responseType);
}

export function isPayloadActionResponse<T>(object): object is PayloadActionResponse<T> {
    return !!(object && object.payload && object.finished !== undefined && object.responseType);
}

export function isModalWindowResult(object): object is ModalWindowResult {
    return !!(
        object &&
        object.finishedResponse &&
        object.isSuccessful !== undefined &&
        object.reopen !== undefined &&
        isActionResponse(object.finishedResponse)
    );
}

function isDocumentType(type: string): boolean {
    return type === recordTypes.TYPE_DOCUMENT;
}

export function isDocument(object): object is RichDocument {
    return !!(object && object.type && isDocumentType(object.type));
}

export function isObject(object: unknown): object is Record<string, never> {
    const type = typeof object;
    return type === 'function' || type === 'object' && !!object;
}

export function isExtendedDocument(document: RichDocument): document is ExtendedDocument {
    const object = document as any;
    return !!(object && object.getFields && object.getSubfields);
}

export function assertIsString(value: any): asserts value is string {
    if (typeof value !== 'string') {
        throw new Error(`${value} is not a string`)
    }
}